import type { JSX } from "react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";
import { Button, ErrorState } from "@mailflare/ui";

import { routes } from "@/features/mailboxes/routes";

function describe(error: unknown): string {
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`;
  if (error instanceof Error) return error.message;
  return "An unexpected error occurred.";
}

export function RouteErrorPage(): JSX.Element {
  const error = useRouteError();
  return (
    <main className="flex min-h-dvh items-center justify-center p-4">
      <div className="w-full max-w-md">
        <ErrorState
          title="MailFlare hit a problem"
          message={describe(error)}
          onRetry={() => window.location.reload()}
          retryLabel="Reload"
        />
        <div className="mt-2 text-center">
          <Button asChild variant="ghost" size="sm">
            <Link to={routes.root}>Back to mail</Link>
          </Button>
        </div>
      </div>
    </main>
  );
}
